export default {
  heading: "帳戶關聯",
  info: "為提供全方位個人化服務，您可以綁定您的校本專屬帳戶到個人會員帳戶。個人會員帳戶由您擁有，可以自行管理帳戶及永久檢視於教城完整的用戶資料及活動紀錄而不受升班或轉校影響。",
  associateFromHeading: "請輸入要關聯的帳戶的登入名稱和密碼",
  associatedActiveHeading: "已關聯的有效帳戶",
  listHeading: "關聯的舊有帳戶列表",
  label: {
    password: "密碼",
    closeBtn: "關閉",
    actions: "動作",
  },
  button: {
    remove: "取消關聯",
  },
  validations: {
    passwordIsEmpty: "請輸入關聯帳戶的密碼",
    passwordInvalid: "無效的密碼格式",
    cityIdIsEmpty: "請輸入關聯帳戶的登入名稱",
    cityIdInvalid: "無效的登入名稱",
  },
  serverErrors: {
    wrongPasswordOrUserNotFound: "帳戶不存在或密碼不正確",
    notStudent: "只能關聯學生帳戶",
    inactiveAssociateAccount: "不能取消此帳戶關聯",
    alreadyHasActiveAssociation: "已關聯學生帳戶",
    non_full_member: "您的帳戶不能關聯其他帳戶",
    invalid_relationship_nature: "只能關聯學生帳戶",
    duplicated_relationship_nature: "不能重複關聯",
    not_exist_user_relationship: "不存在此帳戶關聯",
  },
  confirmDialog: {

    associate: {
      content: "確認關聯?",
      confirm: "關聯",
      cancel: "取消",
    },
    remove: {
      content: "確認取消關聯?",
      confirm: "取消關聯",
      cancel: "取消",
    },
  },
};
